import { ChangeDetectionStrategy, Component, EventEmitter, Output, inject } from '@angular/core';
import { ModalService } from '@shared/services/modal.service';
;

@Component({
  selector: 'app-close-session-modal',
  imports: [],
  template: `
    <div class="modal fade" id="closeSessionModal" tabindex="-1" aria-labelledby="closeSessionModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content rounded-3 shadow-sm">
          <div class="modal-header border-bottom">
            <h5 class="modal-title text-neutrals-800 fw-bold" id="closeSessionModalLabel">Cerrar Sesión</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="onCancel()"></button>
          </div>
          <div class="modal-body text-center py-4">
            <div class="d-flex justify-content-center mb-3">
              <div class="rounded-circle bg-danger bg-opacity-10 p-4">
                <img src="assets/icons/exclamation-octagon-fill.svg" alt="Cerrar Sesión Icono" class="img-fluid" style="max-width: 120px; height: 120px; filter: invert(27%) sepia(97%) saturate(5533%) hue-rotate(350deg) brightness(85%) contrast(93%);" />
              </div>
            </div>
            <p class="text-neutrals-800 mb-3">¿Estás seguro que deseas cerrar sesión?</p>
          </div>
          <div class="modal-footer border-top d-flex gap-2">
            <button type="button" class="btn btn-link text-primary-300 fw-bold text-decoration-none rounded-pill flex-fill" data-bs-dismiss="modal" (click)="onCancel()">Cancelar</button>
            <button type="button" class="btn btn-outline-primary-300 fw-bold rounded-pill flex-fill" data-bs-dismiss="modal" (click)="onConfirm()">Cerrar Sesión</button>
          </div>
        </div>
      </div>
    </div>
  `,
  styleUrl: './close-session-modal.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CloseSessionModalComponent { 
  @Output('on-confirm') confirmEvent = new EventEmitter<boolean>(false);
  
  private modalService = inject(ModalService);

  onConfirm(): void {
    this.modalService.hideCloseSession();
    this.confirmEvent.emit(true);
  }

  onCancel(): void {
    this.modalService.hideCloseSession();
    this.confirmEvent.emit(false);
  }
}
